/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Kolektif Oluşum API
 * Kolektif Oluşum API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateContactDto,
  CreateUserDto,
  DiscountDto,
  LoginDto,
  LoginResponseDto,
  UserResponseDto,
} from "./kolektifOluşumAPI.schemas";

import { customInstance } from "../../../axiosConfig";

export const appControllerGetHello = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/`, method: "GET", signal });
};

export const getAppControllerGetHelloQueryKey = () => {
  return [`/`] as const;
};

export const getAppControllerGetHelloQueryOptions = <
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof appControllerGetHello>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAppControllerGetHelloQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof appControllerGetHello>>
  > = ({ signal }) => appControllerGetHello(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof appControllerGetHello>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AppControllerGetHelloQueryResult = NonNullable<
  Awaited<ReturnType<typeof appControllerGetHello>>
>;
export type AppControllerGetHelloQueryError = unknown;

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof appControllerGetHello>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof appControllerGetHello>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof appControllerGetHello>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof appControllerGetHello>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAppControllerGetHelloQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submit contact form
 */
export const contactControllerCreate = (
  createContactDto: CreateContactDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/contact`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createContactDto,
    signal,
  });
};

export const getContactControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contactControllerCreate>>,
    TError,
    { data: CreateContactDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contactControllerCreate>>,
  TError,
  { data: CreateContactDto },
  TContext
> => {
  const mutationKey = ["contactControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contactControllerCreate>>,
    { data: CreateContactDto }
  > = (props) => {
    const { data } = props ?? {};

    return contactControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContactControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof contactControllerCreate>>
>;
export type ContactControllerCreateMutationBody = CreateContactDto;
export type ContactControllerCreateMutationError = void;

/**
 * @summary Submit contact form
 */
export const useContactControllerCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contactControllerCreate>>,
      TError,
      { data: CreateContactDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contactControllerCreate>>,
  TError,
  { data: CreateContactDto },
  TContext
> => {
  const mutationOptions = getContactControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Register a new user
 */
export const authControllerRegister = (
  createUserDto: CreateUserDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/auth/register`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createUserDto,
    signal,
  });
};

export const getAuthControllerRegisterMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRegister>>,
    TError,
    { data: CreateUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerRegister>>,
  TError,
  { data: CreateUserDto },
  TContext
> => {
  const mutationKey = ["authControllerRegister"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerRegister>>,
    { data: CreateUserDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerRegister(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRegister>>
>;
export type AuthControllerRegisterMutationBody = CreateUserDto;
export type AuthControllerRegisterMutationError = void;

/**
 * @summary Register a new user
 */
export const useAuthControllerRegister = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerRegister>>,
      TError,
      { data: CreateUserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerRegister>>,
  TError,
  { data: CreateUserDto },
  TContext
> => {
  const mutationOptions = getAuthControllerRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary User login
 */
export const authControllerLogin = (
  loginDto: LoginDto,
  signal?: AbortSignal,
) => {
  return customInstance<LoginResponseDto>({
    url: `/auth/login`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: loginDto,
    signal,
  });
};

export const getAuthControllerLoginMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogin>>,
    TError,
    { data: LoginDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerLogin>>,
  TError,
  { data: LoginDto },
  TContext
> => {
  const mutationKey = ["authControllerLogin"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerLogin>>,
    { data: LoginDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogin>>
>;
export type AuthControllerLoginMutationBody = LoginDto;
export type AuthControllerLoginMutationError = void;

/**
 * @summary User login
 */
export const useAuthControllerLogin = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerLogin>>,
      TError,
      { data: LoginDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerLogin>>,
  TError,
  { data: LoginDto },
  TContext
> => {
  const mutationOptions = getAuthControllerLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get current user information
 */
export const authControllerGetCurrentUser = (signal?: AbortSignal) => {
  return customInstance<UserResponseDto>({
    url: `/auth/me`,
    method: "GET",
    signal,
  });
};

export const getAuthControllerGetCurrentUserQueryKey = () => {
  return [`/auth/me`] as const;
};

export const getAuthControllerGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthControllerGetCurrentUserQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authControllerGetCurrentUser>>
  > = ({ signal }) => authControllerGetCurrentUser(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerGetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetCurrentUser>>
>;
export type AuthControllerGetCurrentUserQueryError = void;

export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get current user information
 */

export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAuthControllerGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user information by ID
 */
export const authControllerGetUserById = (id: string, signal?: AbortSignal) => {
  return customInstance<UserResponseDto>({
    url: `/auth/user/${id}`,
    method: "GET",
    signal,
  });
};

export const getAuthControllerGetUserByIdQueryKey = (id: string) => {
  return [`/auth/user/${id}`] as const;
};

export const getAuthControllerGetUserByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerGetUserById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetUserById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthControllerGetUserByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authControllerGetUserById>>
  > = ({ signal }) => authControllerGetUserById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerGetUserById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerGetUserByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetUserById>>
>;
export type AuthControllerGetUserByIdQueryError = void;

export function useAuthControllerGetUserById<
  TData = Awaited<ReturnType<typeof authControllerGetUserById>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetUserById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetUserById>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetUserById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthControllerGetUserById<
  TData = Awaited<ReturnType<typeof authControllerGetUserById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetUserById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetUserById>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetUserById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthControllerGetUserById<
  TData = Awaited<ReturnType<typeof authControllerGetUserById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetUserById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user information by ID
 */

export function useAuthControllerGetUserById<
  TData = Awaited<ReturnType<typeof authControllerGetUserById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetUserById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAuthControllerGetUserByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all discounts
 */
export const discountsControllerFindAll = (signal?: AbortSignal) => {
  return customInstance<DiscountDto[]>({
    url: `/discounts`,
    method: "GET",
    signal,
  });
};

export const getDiscountsControllerFindAllQueryKey = () => {
  return [`/discounts`] as const;
};

export const getDiscountsControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof discountsControllerFindAll>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof discountsControllerFindAll>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDiscountsControllerFindAllQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof discountsControllerFindAll>>
  > = ({ signal }) => discountsControllerFindAll(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof discountsControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DiscountsControllerFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof discountsControllerFindAll>>
>;
export type DiscountsControllerFindAllQueryError = void;

export function useDiscountsControllerFindAll<
  TData = Awaited<ReturnType<typeof discountsControllerFindAll>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discountsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof discountsControllerFindAll>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDiscountsControllerFindAll<
  TData = Awaited<ReturnType<typeof discountsControllerFindAll>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discountsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof discountsControllerFindAll>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDiscountsControllerFindAll<
  TData = Awaited<ReturnType<typeof discountsControllerFindAll>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all discounts
 */

export function useDiscountsControllerFindAll<
  TData = Awaited<ReturnType<typeof discountsControllerFindAll>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDiscountsControllerFindAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a discount by id
 */
export const discountsControllerFindOne = (
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<DiscountDto>({
    url: `/discounts/${id}`,
    method: "GET",
    signal,
  });
};

export const getDiscountsControllerFindOneQueryKey = (id: string) => {
  return [`/discounts/${id}`] as const;
};

export const getDiscountsControllerFindOneQueryOptions = <
  TData = Awaited<ReturnType<typeof discountsControllerFindOne>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDiscountsControllerFindOneQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof discountsControllerFindOne>>
  > = ({ signal }) => discountsControllerFindOne(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof discountsControllerFindOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DiscountsControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof discountsControllerFindOne>>
>;
export type DiscountsControllerFindOneQueryError = void;

export function useDiscountsControllerFindOne<
  TData = Awaited<ReturnType<typeof discountsControllerFindOne>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discountsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof discountsControllerFindOne>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDiscountsControllerFindOne<
  TData = Awaited<ReturnType<typeof discountsControllerFindOne>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discountsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof discountsControllerFindOne>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDiscountsControllerFindOne<
  TData = Awaited<ReturnType<typeof discountsControllerFindOne>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a discount by id
 */

export function useDiscountsControllerFindOne<
  TData = Awaited<ReturnType<typeof discountsControllerFindOne>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discountsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDiscountsControllerFindOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const amplifyWebhookControllerHandleAmplifyWebhook = (
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/webhooks/amplify`,
    method: "POST",
    signal,
  });
};

export const getAmplifyWebhookControllerHandleAmplifyWebhookMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof amplifyWebhookControllerHandleAmplifyWebhook>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof amplifyWebhookControllerHandleAmplifyWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["amplifyWebhookControllerHandleAmplifyWebhook"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof amplifyWebhookControllerHandleAmplifyWebhook>>,
    void
  > = () => {
    return amplifyWebhookControllerHandleAmplifyWebhook();
  };

  return { mutationFn, ...mutationOptions };
};

export type AmplifyWebhookControllerHandleAmplifyWebhookMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof amplifyWebhookControllerHandleAmplifyWebhook>>
  >;

export type AmplifyWebhookControllerHandleAmplifyWebhookMutationError = unknown;

export const useAmplifyWebhookControllerHandleAmplifyWebhook = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof amplifyWebhookControllerHandleAmplifyWebhook>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof amplifyWebhookControllerHandleAmplifyWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getAmplifyWebhookControllerHandleAmplifyWebhookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
